import React, { Fragment } from 'react';
import Slider from 'react-slick';
import * as icones from '../Icones'
import * as tools from '../Tools';
import { Link } from 'react-router-dom';
import isExternal from 'is-url-external';



function CarousselNextArrow(props) {
	const { className, style, onClick } = props;
	return (
		<span
			className="caroussel-next"
			// style={{ ...style, display: "block", background: "red" }}
			onClick={onClick}
		>
			<icones.next />
		</span>
	);
}

function CarousselPrevArrow(props) {
	const { className, style, onClick } = props;
	return (
		<span
			className="caroussel-prev"
			style={{}}
			onClick={onClick}
		>
			<icones.prev />
		</span>
	);
}

// const lien = "https://storage.timothee.fr/ftp/sites/photos/";

export class ModuleCaroussel extends React.Component {
	constructor(props) {
		super(props);
	}



	render() {

		const affichageIcone = iconeName => {
			if(iconeName === "lire"){
				return <icones.lire className="icone"  width={80} />
			}
			if(iconeName === "ecouter"){
				return <icones.ecouter className="icone"  width={80} />
			}
			if(iconeName === "regarder"){
				return <icones.regarder className="icone"  width={80} />
			}
		}


		const Contenu = props => <div className="text-center p-3" style={{}}>
			<figure className="effect-ming text-center" style={{ position: 'relative', left: '50%',transform: 'translate(-50%, 0)' }}>

					{props.element.imgSrc.includes("http") ?
						<img src={props.element.imgSrc} alt="img09" className="img-fluid" />
						:
						<img src={tools.lienPhotos + "/" + props.element.imgSrc} alt="img09" className="img-fluid" />
					}
					<figcaption >
						<p style={{ position: 'absolute', top: '50%', left: '50%', display: 'inline', transform: 'translate(-50%,-50%)' }} >
							{ props.element.icone ? props.element.icone : affichageIcone(props.element.iconeName) || <icones.ecouter width={80} />}
						</p>
					</figcaption>

			</figure>
			<div style={{ width: "100%", float: 'left' }}>
				<div style={{ backgroundColor: props.element.color ? props.element.color : tools[props.element.colorName] || "#7cb4d7", float: 'left', width: '100%' }} className="pt-1 pb-1 pl-3 pr-3 mt-1 text-uppercase text-white" >
					<strong>{props.element.type || ""}</strong>
				</div>
				<div className="pt-2" style={{ fontSize: '1.1em' }}><strong>{props.element.titre1 || ""}</strong></div>
				<div style={{ fontSize: '0.8em' }}><strong>{props.element.titre2 || ""}</strong></div>
				<div style={{ fontSize: '0.6em' }}>{props.element.titre3 || ""}</div>
			</div>
		</div>

		const childElements = this.props.elements.map(element => {
			return (<Fragment key={element.key}>
					{isExternal(element.lien) ? (
						<a
							href={element.lien || "/actualites"}
							target="_blank"
							style={{ textDecoration: 'none' }}
							className="lienSlide"
						>
							<Contenu element={element} />
						</a>
					) : (
							<Link to={element.lien || "/actualites"} className="lienSlide" style={{ textDecoration: 'none !important' }}>
								<Contenu element={element} />
							</Link>
						)}
				</Fragment>)
		});

		var settings = {
			dots: true,
			infinite: true,
			speed: 100,
			slidesToShow: 5,
			slidesToScroll: 5,
			autoplay: false,
			arrows: false,
			// nextArrow: <CarousselNextArrow />,
			// prevArrow: <CarousselPrevArrow />,

			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
						infinite: true,
						dots: true,
						arrows: false
					}
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
				// You can unslick at a given breakpoint now by adding:
				// settings: "unslick"
				// instead of a settings object
			]
		};
		return (
			<React.Fragment>
				<div className="gridSlide">
					<Slider {...settings}>{childElements}</Slider>
				</div>
			</React.Fragment>
		);
	}
}

